export function getList(fetch, filtro) {
  return fetch().post("contas/getlist", filtro);
}

export function getById(fetch, id) {
  return fetch().post(`contas/${id}`);
}
